// extracted by mini-css-extract-plugin
module.exports = {"section":"ProductBundle_section__Daa8D"};